module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('v-ons-splitter', [(_vm.getIfLoggedIn()) ? _c('v-ons-splitter-side', {
    attrs: {
      "swipeable": "",
      "collapse": "",
      "width": "250px",
      "open": _vm.menuIsOpen
    },
    on: {
      "update:open": function($event) {
        _vm.menuIsOpen = $event
      }
    }
  }, [_c('side-menu')], 1) : _vm._e(), _vm._v(" "), _c('v-ons-splitter-content', [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 719
// module chunks = 1